// extracted by mini-css-extract-plugin
module.exports = {"blue":"#109cf1","green":"#2ed47a","yellow":"#ffb946","orchid":"#ba4de1","skyblue":"#61e2e2","gray400":"#c0c9d5","whitesmoke":"#f5f7f9","brightgray":"#e7ebf0"};